export const comApiVersion = '1.0.0';
export const comApiConnexionWaitingDelay = 5000;
export const CHANNEL_HUB_SERVICE = 'CHANNEL_HUB_SERVICE';
